import merge from "deepmerge"
import Admin from "./admin"
import BasicBlockRendering from "./basic-block-rendering"
import BasicMarkRendering from "./basic-mark-rendering"
import Captioned from "./captioned"
import ChangeBlock from "./change-block"
import Color from "./color"
import CustomDraggable from "./custom-draggable"
import Rendering from "./rendering"
import FontSize from "./font-size"
import Images from "./images"
import Links from "./links"
import Lists from "./lists"
import MarkShortcuts from "./mark-shortcuts"
import MarkdownShortcuts from "./markdown-shortcuts"
import Pasting from "./pasting"
import Placeholder from "./node-placeholder"
import ResetBlockOnBackspace from "./reset-block-on-backspace"
import ResetBlockOnEnter from "./reset-block-on-enter"
import SoftBreak from "./soft-break"
import UnhangSelectionOnTripleClickInButton from "./unhang-selection-on-triple-click-in-button"
import Videos from "./videos"
import Schema from "./schema"
import SlateNodes from "../slate-nodes"

import defaultConfig from "../default-config"

const HEADING_BLOCKS = [
  "heading-one",
  "heading-two",
  "heading-three",
  "heading-four",
  "heading-five",
  "heading-six"
]

const Placeholders = [
  Placeholder({ type: "heading-one", placeholder: "Heading 1" }),
  Placeholder({ type: "heading-two", placeholder: "Heading 2" }),
  Placeholder({ type: "heading-three", placeholder: "Heading 3" }),
  Placeholder({ type: "heading-four", placeholder: "Heading 4" }),
  Placeholder({ type: "heading-five", placeholder: "Heading 5" }),
  Placeholder({ type: "heading-six", placeholder: "Heading 6" }),
  Placeholder({ type: "caption", placeholder: "caption for image" })
]

const Before = config => {
  return [
    Admin(),
    SlateNodes(),
    BasicBlockRendering(),
    BasicMarkRendering(),
    Rendering(),
    CustomDraggable(),
    config.fonts.size && FontSize(),
    MarkShortcuts(),
    MarkdownShortcuts(config),
    Schema(),
    config.fonts.color && Color(),
    config.lists && Lists(),
    Videos(),
    ...Placeholders
  ].filter(Boolean)
}

const After = config => {
  return [
    SoftBreak({ shift: true }),
    Links(),
    Images(config.images),
    ChangeBlock(),
    Pasting(),
    Captioned({ type: "image" }),
    ResetBlockOnBackspace({
      blocks: [...HEADING_BLOCKS, "button"],
      defaultBlock: "paragraph"
    }),
    ResetBlockOnEnter({
      exclude: [],
      defaultBlock: "paragraph"
    }),
    UnhangSelectionOnTripleClickInButton()
  ].filter(Boolean)
}

export default (userConfig = {}, plugins = []) => {
  const config = merge(defaultConfig, userConfig)
  return [...Before(config), ...plugins, ...After(config)]
}
